import {
  SubmitFormRequestElementResult,
  SubmitFormRequestElementResultCellDefaultResult,
} from '@cash-web/protos/squareup/franklin/app/submit_form.pb'
import {
  FormBlocker,
  FormBlockerElement,
  FormBlockerElementCellDefaultElement,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'

const cellDefaultElementDefaultValue = (
  cellDefaultElement: FormBlockerElementCellDefaultElement
): Record<'cell_default_result', SubmitFormRequestElementResultCellDefaultResult> | undefined => {
  const hasInput = cellDefaultElement.cell?.accessory?.checkbox || cellDefaultElement.cell?.accessory?.radio
  if (hasInput) {
    return {
      cell_default_result: {
        selection_group_id: cellDefaultElement.selection_group_id,
        is_checked: cellDefaultElement.initial_selection ?? false,
      },
    }
  }
  // We do not need to set any default values for cells that do not have an accessory with an input
  return undefined
}

const elementToDefaultValueMapper = {
  cell_default_element: cellDefaultElementDefaultValue,
}

type BlockerElementKey = keyof typeof elementToDefaultValueMapper

const hasDefaultValue = (key: string): key is BlockerElementKey => key in elementToDefaultValueMapper

/**
 * Builds initial form values from FormBlocker elements that have default selections.
 * Used to pre-populate form state before user interaction.
 */
export function setDefaultFormBlockerValues(blocker: FormBlocker) {
  const { elements } = blocker
  const defaultFormValues: Record<string, SubmitFormRequestElementResult> = {}

  elements?.forEach((element: FormBlockerElement, formSectionIndex: number) => {
    const { id, ...restOfElement } = element

    // Identify the element type by finding the non-null property (e.g., 'cell_default_element')
    const elementName = Object.keys(restOfElement).find(key => restOfElement[key as keyof typeof restOfElement] != null)

    if (elementName && hasDefaultValue(elementName)) {
      const value = restOfElement[elementName]
      if (value) {
        const elementDefaultValue = elementToDefaultValueMapper[elementName](value)
        if (elementDefaultValue) {
          // Use the index as the key to match form submission structure
          defaultFormValues[formSectionIndex] = elementDefaultValue
        }
      }
    }
  })

  return defaultFormValues
}
